import Box from 'Components/Box';
import Button from 'Components/Button';
import Cookies from 'js-cookie';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { IS_DISONA } from 'common/utils/style.util';
import styled, { ThemeProvider } from 'styled-components';
import { ifProp } from 'styled-tools';
import theme from 'themes/darkTheme';
import media from 'themes/media';

const Container = styled.div`
  display: ${ifProp('isDisona', 'none', 'flex')};
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  background: ${(props) => props.theme.colors.background.backgroundComponent};
  border-top: 1px solid ${(props) => props.theme.colors.background.borderColor};
`;

const Content = styled.div`
  padding: 16px;
  flex-grow: 1;
  max-width: 700px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  ${media.lessThan('700px')`
    justify-content: center;
  `}
`;

const Text = styled.div`
  color: white;
  margin: 16px 0;
`;

class InstallApp extends React.Component {
  state = {};

  componentDidMount() {
    const isHidden = Cookies.get('hide-install-app');

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // // Stash the event so it can be triggered later.
      this.setState({ deferredPrompt: e });
    });

    this.setState({
      isHidden,
    });
  }

  onCancel = () => {
    Cookies.set('hide-install-app', true);
    this.setState({
      isHidden: true,
    });
  };

  onInstall = () => {
    const { deferredPrompt } = this.state;
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === 'accepted') {
          console.log('Your PWA has been installed');
          Cookies.set('hide-install-app', true);
        } else {
          console.log('User chose to not install your PWA');
        }

        this.setState({ deferredPrompt: null });
      });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <ThemeProvider theme={theme}>
        {!this.state.isHidden && this.state.deferredPrompt && (
          <Container isDisona={IS_DISONA}>
            <Content>
              <Text>{t('common.installApp.addApp')}</Text>
              <Box mt={4} mb={4} ml={8} mr={8}>
                <Button mr={8} inline type="primary" onClick={this.onInstall}>
                  {t('common.installApp.installBtn')}
                </Button>
                <Button type="secondary" ml={8} inline onClick={this.onCancel}>
                  {t('common.installApp.cancelBtn')}
                </Button>
              </Box>
            </Content>
          </Container>
        )}
      </ThemeProvider>
    );
  }
}

export default withTranslation()(InstallApp);
